var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";
import { Event } from "../models/enums";
import { EventBus } from "../services/eventbus.service";
let AppToast = class AppToast extends LitElement {
    constructor() {
        super();
        this._toasts = [];
        this.toastEvent = (event) => {
            const toast = event.detail;
            this._toasts.push(toast);
            this.requestUpdate();
            setTimeout(() => {
                this._toasts.shift();
                this.requestUpdate();
            }, 2500);
        };
        this.eventbus = EventBus.getInstance();
    }
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback();
        this.eventbus.addEventListener(Event.Toast, this.toastEvent);
    }
    disconnectedCallback() {
        this.eventbus.removeEventListener(Event.Toast, this.toastEvent);
        super.disconnectedCallback();
    }
    firstUpdated() { }
    render() {
        return html `
        ${this._toasts.map((toast) => html `
            <div class="notification shadow ${toast.type ? toast.type : " is-success"} is-light p-3" style="display:inline-block;">
                <i class="${toast.classes}"></i>
                ${toast.text}
            </div><br>
        `)}
        `;
    }
};
AppToast = __decorate([
    customElement("app-toast")
], AppToast);
export { AppToast };
//# sourceMappingURL=toast.component.js.map